import React from 'react';
import { Masonry } from '@forgeglobal/design-framework';
import { useParams } from 'react-router-dom';
import useMasonryDynamicColumns from '@tcs/common/hooks/useMasonryDynamicColumns';
import PersonalInfoCard from '@tcs/client-portal-common/components/templates/DetailCards/PersonalInfoCard';
import AddressCard from '@tcs/client-portal-common/components/templates/DetailCards/AddressCard';
import ContactInfoCard from '@tcs/client-portal-common/components/templates/DetailCards/ContactInfoCard';
import useAccountProfile from '@tcs/client-portal-common/hooks/useAccountProfile';
import Spinner from '@tcs/common/components/atoms/Spinner';

const AccountInfo = () => {
  const params = useParams<{ accountNumber: string }>();
  const { loading, data: profile } = useAccountProfile(params.accountNumber);

  const columnNum = useMasonryDynamicColumns('lg', 2);

  if (loading) {
    return <Spinner />;
  }

  if (!profile) {
    // @TODO: loading profile. Show spinner
    return null;
  }

  const { personalInfo, contactInfo, address } = profile;

  return (
    <Masonry numCols={columnNum}>
      <PersonalInfoCard personalInfo={personalInfo} />
      <AddressCard address={address} />
      <ContactInfoCard contactInfo={contactInfo} />
    </Masonry>
  );
};

export default AccountInfo;
